export default {
  "content": "<path fill=\"#fff\" fill-rule=\"evenodd\" d=\"M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24z\" clip-rule=\"evenodd\"/><path fill-rule=\"evenodd\" stroke=\"#00809D\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M24.51 27.574a7.149 7.149 0 100-14.298 7.149 7.149 0 00.001 14.298z\" clip-rule=\"evenodd\"/><path stroke=\"#00809D\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M20.64 26.44l-1.236 9.305 5.107-3.064 5.106 3.064-1.236-9.314\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "48",
    "height": "48",
    "fill": "none",
    "viewBox": "0 0 48 48"
  }
};